import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Goal, Icon, ErrorBoundary, Title } from 'components'
import { getGoalSummaries } from 'store/selectors'
import {
  deleteGoal,
  setActiveGoal,
  deleteAllGoals,
  setGoalProp,
  setPlanProp,
} from 'store/actions'

function Sidebar(props) {
  const {
    age,
    savings,
    planName,
    goals,
    activeGoal,
    history,
    location,
    setActiveGoal,
    setGoalProp,
    setPlanProp,
    menuOpen,
  } = props
  return (
    <aside style={menuOpen ? { visibility: 'visible' } : {}}>
      <ErrorBoundary>
        <div>
          <Title
            value={planName}
            category={'My Plan'}
            editTitle={value => setPlanProp('planName', value)}
          />
          <Link to="/profile">
            <button className="minimal">
              <Icon name="edit-line-primary" small />
              EDIT
            </button>
          </Link>
        </div>
        <div>
          I'm <strong>{age} years</strong> old
          <br />I have saved <strong>&#8377; {savings} Lakhs</strong>
        </div>
        <div>
          <h5>GOALS</h5>
          <div>
            <Link
              to={`${location.pathname === '/' ? '' : location.pathname}/clear`}
            >
              <h5>CLEAR</h5>
            </Link>
            <Link
              to={`${location.pathname === '/' ? '' : location.pathname}/new`}
            >
              <button className="minimal">
                <Icon name="plus-line-primary" small />
                NEW
              </button>
            </Link>
          </div>
        </div>
        <div>
          {goals.length > 0 ? (
            goals.map((goal, idx) => (
              <Goal
                key={goal.id}
                id={goal.id}
                icon={goal.icon}
                title={goal.title}
                category={goal.category}
                text={goal.summary}
                active={goal.id === activeGoal}
                editTitle={value => setGoalProp(goal.id, 'title', value)}
                onClick={() => {
                  history.push(`/edit/${goal.id}`)
                  setActiveGoal(goal.id)
                }}
              />
            ))
          ) : (
            <div className="noGoals">
              New goals will show up as cards here.
              <br />
              Click on a card to edit and customize the goal to your needs.
            </div>
          )}
        </div>
      </ErrorBoundary>
    </aside>
  )
}

export default connect(
  state => ({
    age: state.profile.age,
    savings: Math.round(state.profile.savings / 100000),
    planName: state.profile.planName.toUpperCase(),
    goals: getGoalSummaries(state),
    activeGoal: state.activeGoal,
    menuOpen: state.display.menuOpen,
  }),
  { deleteGoal, setActiveGoal, deleteAllGoals, setGoalProp, setPlanProp }
)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/layout/Sidebar.js